<template>
  <Transition name="force-update-fade">
    <div
      v-if="show"
      dir="rtl"
      class="force-update-screen fixed inset-0 flex flex-col items-center justify-center px-8 text-center text-white bg-gradient-to-b from-[#1b1136] to-[#24104A]"
    >
      <div class="w-24 h-24 mb-8 rounded-[28px] bg-white/10 flex items-center justify-center">
        <i class="pi pi-sparkles text-5xl text-primary-200"/>
      </div>

      <h1 class="text-2xl font-bold mb-3">
        יש גרסה חדשה לאפליקציה
      </h1>
      <p class="text-base text-white/75 leading-relaxed max-w-xs mb-2">
        כדי להמשיך להשתמש ב-TimeIt יש לעדכן לגרסה האחרונה. העדכון לוקח רק כמה שניות.
      </p>
      <p v-if="version" class="text-sm text-white/50 mb-10">
        גרסה {{ version }}
      </p>
      <div v-else class="mb-10"/>

      <Button
        :label="isIOS ? 'עדכון ב-App Store' : 'עדכון ב-Google Play'"
        icon="pi pi-download"
        :loading="loading"
        class="w-full max-w-xs !py-3 !text-lg !font-semibold !rounded-2xl"
        @click="emit('update')"
      />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core';

defineProps<{
  show: boolean;
  version?: string;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update'): void;
}>();

const isIOS = Capacitor.getPlatform() === 'ios';
</script>

<style scoped>
.force-update-screen {
  /* Above PrimeVue overlays, IOSDrawer and dialogs — nothing should be reachable behind it */
  z-index: 100000;
  padding-top: calc(env(safe-area-inset-top) + 2rem);
  padding-bottom: calc(env(safe-area-inset-bottom) + 2rem);
}

.force-update-fade-enter-active,
.force-update-fade-leave-active {
  transition: opacity 0.3s ease;
}

.force-update-fade-enter-from,
.force-update-fade-leave-to {
  opacity: 0;
}
</style>
